<template>
  <div id="landingPage" class="bg-light-grey-background w-full relative flex justify-center items-center" style="margin-top: -6vh; padding-top: 7vh; padding-bottom: 7vh">
    <div class="flex justify-center items-center">
      <div class="relative" style="width: 26.4vw" v-if="Object.keys(eggImgObj).length != 0" :class="[eggImgObj.margin ? eggImgObj.margin : 'mr-24']">
        <img :src="commonStore.getImgUrl(eggImgObj.componentName, eggImgObj.imgName, eggImgObj.imgFormat)" style="width: inherit" />
      </div>
      <div class="text-left" :style="textWidth ? 'width: ' + textWidth : 'width: 24vw'">
        <div class="font-bold" v-html="t(label)" :style="'color:' + labelColor" :class="[labelFontSize]" />
        <div class="font-jost" :class="[descFontSize]" v-html="t(description)" :style="'color:' + descColor"></div>
      </div>
    </div>

    <div class="mb-14 absolute right-0 bottom-0" style="width: 9.5vw" v-if="Object.keys(starBackgroundObj).length != 0">
      <img :src="commonStore.getImgUrl(starBackgroundObj.componentName, starBackgroundObj.imgName, starBackgroundObj.imgFormat)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => {});

import { toRefs } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  labelColor: {
    type: String,
    default: "#494949",
  },
  labelFontSize: {
    type: String,
    default: "text-6xl",
  },
  descColor: {
    type: String,
    default: "#494949",
  },
  descFontSize: {
    type: String,
    default: "text-lg",
  },
  textWidth: {
    type: String,
  },
  eggImgObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  starBackgroundObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
});
</script>

<style>
</style>